import { Color, colors } from "theme";

type StarIconProps = {
  fill?: Color | string;
};

export const StarIcon = ({ fill = colors.grey[10] }: StarIconProps) => (
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4993 21.0267L21.7393 26L19.5527 16.6267L26.8327 10.32L17.246 9.50669L13.4993 0.666687L9.75268 9.50669L0.166016 10.32L7.44602 16.6267L5.25935 26L13.4993 21.0267Z"
      fill={fill}
    />
  </svg>
);
